import View from "./payments-report.view";
import Presenter from "./payments-report.presenter";
import { ConnectComponent } from "util";

const states = [
  {
    name: "app.management.payments-report",
    url: "/pagamentos",
    views: {
      "content@app": ConnectComponent(View, Presenter)
    },
    data: {
      navigation: {
        name: "Pagamentos",
        priority: 100,
        authorization: context =>
          context.user.permissions.includes("view_closed_sales"),
        state: "app.management.payments-report"
      }
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/management/payments-report/index.js